import EventEmitter from "eventemitter3";

const eventBus = new EventEmitter();
export default eventBus;

export const EVENTS = {
  CANCEL_REGENERATE_PREVIEW_CREATIVES: "cancelRegeneratePreviewCreatives"
};

export const cancelRegeneratePreviewCreatives = () => {
  eventBus.emit(EVENTS.CANCEL_REGENERATE_PREVIEW_CREATIVES);
};
